import * as React from 'react';
import { css, StyleSheet } from 'aphrodite';
import { Colors, drawerWidth, MediaBreakPointUp } from '../styles';
export const InitialGuideQA = ({ question, children }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: css(styles.question) }, question),
        React.createElement("div", { className: css(styles.answer) }, children)));
};
const styles = StyleSheet.create({
    question: {
        position: 'relative',
        textAlign: 'center',
        color: Colors.White,
        backgroundColor: Colors.PrimaryDark,
        width: '100%',
        padding: '14px 6px 0',
        marginTop: 30,
        marginBottom: 46,
        borderRadius: 4,
        '::after': {
            content: "''",
            borderStyle: 'solid',
            borderWidth: '32px calc(50vw - 24px) 0',
            borderColor: `${Colors.PrimaryDark} transparent transparent transparent`,
            position: 'absolute',
            top: '97%',
            left: 0,
            right: 0,
        },
        [MediaBreakPointUp.MD]: {
            '::after': {
                borderWidth: `32px calc(50vw - 40px - (${drawerWidth.md}px / 2)) 0`,
            },
        },
        [MediaBreakPointUp.XL]: {
            '::after': {
                borderWidth: `32px 308px 0`,
            },
        },
    },
    answer: {
        fontSize: 14,
        fontWeight: 400,
        marginBottom: 30,
        lineHeight: '160%',
        letterSpacing: '0.56px',
    },
});
